module.exports = __webpack_public_path__ + "img/banner-ru40x80.040fcf55.jpg";